import React from 'react';
import Select from 'react-select';
import { HalfCircleSpinner } from 'react-epic-spinners';
import { FormGroup, Label, Col } from 'reactstrap';
import { isEmpty, noop } from 'lodash';

const FormInputSelect = ({
  className,
  control,
  handleChange = noop,
  handleKeyDown = noop,
  handleBlur = noop,
  hideCaption = false,
  inputColStyle = {},
  isClearable = false,
  isDisabled = false,
  labelStyle = {},
  isGrouped = false,
  groupLabel = null,
  size = null,
  selectFirst = true
}) => {
  const createOptions = (options) =>
    Array.isArray(options) && !isEmpty(options)
      ? options.map(({ id, name }) => ({ value: id ?? '', label: name }))
      : [];
  const createGroupOptions = (groupOptions) =>
    Array.isArray(groupOptions) && !isEmpty(groupOptions)
      ? groupOptions.map(({ groupLabel: label, options }) => {
          const formattedOptions = options.map(({ id, name }) => ({
            value: id ?? '',
            label: name,
          }));
          return { label, options: formattedOptions };
        })
      : [];

  let { value } = control;
  const options = isGrouped ? createGroupOptions(control.options) : createOptions(control.options);

  value = options?.find((option) => option.value === value) ?? null;

  if (value === null && selectFirst && options.length > 0) [value] = options;

  if (isGrouped && groupLabel) value = { label: groupLabel };

  let selectStyles = null;

  // Size in px (string) ...ie 30px is good for a small select
  if (size) {
    selectStyles = {
      control: (provided, state) => ({
        ...provided,
        minHeight: size,
        height: size,
      }),
      valueContainer: (provided, state) => ({
        ...provided,
        height: size,
        padding: '0 10px',
        fontSize: '13px',
        zIndex: 0
      }),
      input: (provided, state) => ({
        ...provided,
        margin: '0px',
        padding: '0px',
        zIndex: 0
      }),
      indicatorSeparator: state => ({
        display: 'none',
      }),
      indicatorsContainer: (provided, state) => ({
        ...provided,
        height: size,
      }),
      option: (provided, state) => ({
        ...provided,
        fontSize: 13
      }),
      menu: (provided, state) => ({
        ...provided,
        width: 'max-content',
        minWidth: '100%',
        zIndex: 0
      }),
    };
  }
  if (control.disabled) isDisabled = true;

  return (
    <div className="mt-0 mb-0 row">
      {control.caption && !hideCaption && (
        <Label for={control.name} sm={12} className="fw-bold" style={labelStyle}>
          {control.caption}
        </Label>
      )}
      <Col sm={12} style={inputColStyle}>
        <Select
          inputId={control.name}
          name={control.name}
          className={`${className ?? ''}${control.warning ? ' input-warning-border' : ''}`}
          isClearable={isClearable}
          isDisabled={isDisabled}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          options={options}
          value={value}
          styles={selectStyles || {}}
          placeholder={control.placeholder}
        />
        {control.loading && (
          <HalfCircleSpinner size={20} color="grey" className="mt-1 p-1 ml-n4-half" />
        )}
        {!control.valid && <small className="text-danger">{control.message}</small>}
        {control.valid && control.warning && (
          <small className="text-warning">{control.message}</small>
        )}
        {control.description && <small className="text-success">{control.description}</small>}
      </Col>
    </div>
  );
};

export default FormInputSelect;
